import { Image } from '@tiptap/extension-image';

const AlignableImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      src: {
        default: null,
        parseHTML: (element) => element.getAttribute('src') || null,
        renderHTML: (attributes) => ({
          src: attributes.src,
        }),
      },
      align: {
        default: 'center',
        parseHTML: (element) => element.getAttribute('data-align') || 'center',
        renderHTML: (attributes) => {
          let className = '';
          let style = `border-radius: 8px;`;
          if (attributes.align === 'left') className = 'float-left mr-4';
          else if (attributes.align === 'right') className = 'float-right ml-4';
          else className = 'mx-auto block';
          if (attributes.width) style += `width: ${attributes.width};`;
          return {
            'data-align': attributes.align,
            class: `${className} cursor-pointer`,
            style,
          };
        },
      },
      width: {
        default: '100%',
        parseHTML: (element) => element.getAttribute('data-width') || '100%',
        renderHTML: (attributes) => ({
          'data-width': attributes.width,
          style: `width: ${attributes.width}`,
        }),
      },
    };
  },
});

export default AlignableImage;
